/**
 * Matches Reservation/Blog/Consultation route guards: feature hidden when explicitly false.
 * While tenant content is loading or missing, show links (avoids empty bar flash).
 */
export function getTenantNavVisibility(content, loading) {
  if (loading || !content) {
    return {
      showReservation: true,
      showBlog: true,
      showConsultation: true,
    };
  }
  return {
    showReservation: content.isReservationPageEnabled !== false,
    showBlog: content.isBlogPageEnabled !== false,
    showConsultation: content.isConsultationPageEnabled !== false,
  };
}
